/** Capitalize first letter of each word */
export function titleCase(s: string): string {
  return s
    .toLowerCase()
    .split(' ')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

/** Generate a short confirmation number from appointment ID + date */
export function makeConfirmationNumber(appointmentId: string, date: string): string {
  const datePart = date.replace(/-/g, '');
  const idPart = appointmentId.slice(-4).toUpperCase();
  return `YB-${datePart}-${idPart}`;
}

/**
 * Minor units → a guest-facing money string. The ONE rule the widget uses for
 * an amount it is about to charge (the card step's "Total to pay" and the
 * coupon-dropped banner must print the same figure the same way). Runtime
 * locale; an unknown currency code falls back to "ZAR 1000.00".
 */
export function formatMoney(cents: number, currency: string): string {
  const major = cents / 100;
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency.toUpperCase(),
    }).format(major);
  } catch {
    return `${currency.toUpperCase()} ${major.toFixed(2)}`;
  }
}
